import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** camelCase / snake_case → "Title case" label. */
export function humanize(key: string): string {
  const spaced = key
    .replace(/Id$/, '')
    .replace(/Ids$/, 's')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .trim()
    .toLowerCase();
  const fixed = spaced
    .replace(/\ben\b$/, '(English)')
    .replace(/\bar\b$/, '(Arabic)')
    .replace(/\bpct\b/g, '%')
    .replace(/\bbp\b/g, '(bp)')
    .replace(/\burl\b/g, 'URL')
    .replace(/\bvat\b/g, 'VAT')
    .replace(/\bqr\b/g, 'QR')
    .replace(/\bhh\b/g, '(hh)')
    .replace(/\bkg\b/g, '(kg)')
    .replace(/\bs$/, '(s)');
  return fixed.charAt(0).toUpperCase() + fixed.slice(1);
}

export function initials(first?: string | null, last?: string | null): string {
  return `${(first ?? '').charAt(0)}${(last ?? '').charAt(0)}`.toUpperCase() || '·';
}

export function isUuid(v: unknown): v is string {
  return typeof v === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(v);
}

export function newIdempotencyKey(): string {
  return crypto.randomUUID();
}

export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export function hashHue(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) % 360;
  return h;
}
